import { render } from "./filtri.vue?vue&type=template&id=66b1c97d"
import script from "./filtri.vue?vue&type=script&lang=js"
export * from "./filtri.vue?vue&type=script&lang=js"

import "./filtri.vue?vue&type=style&index=0&id=66b1c97d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__